import IState from '@/interfaces/IState';

const initialState: IState = {
  pendingRequests: {
    subscriptionTrafficSources: {},
    trafficSources: {},
  },
  access_token: null,
  appleApps: [],
  profile: {
    username: '',
    email: ''
  },
  vpns: [],
  cities: [],
  countries: [],
  dataCenter: [],
  deviceTypes: [],
  accessLevels: [],
  masterServerHistory: [],
  landings:[],
  landingAttributes:[],
  trackers: [],
  trafficSources: {},
  campaigns:[],
  usersGroups: [],
  rebills: [],
  receipts: [],
  tariffs: [],
  roles: [],
  users: [],
  campaignTds: [],
  osDevices: [],
  appleModels: [],
  clientApps: [],
  landingDomains: [],
  landingRegions: [],
  blackListDevices: [],
  tickets: [],
  zodiacDescriptions: [],
  zodiacSigns: [],

  astroEvents: [],

  biorhythms: [],
  biorhythmTypes: [],

  numerologyList: [],
  numerologyTypes: [],

  anotherLifeModelList: [],
  anotherLifeResultList: [],
  cookies: [],

  compatibilities: [],
  compatibilityTypes: [],
  compatibilityScore: [],

  famousBabyModelList: [],
  famousBabyResultList: [],
  futureBaby: [],

  horoscopeTypes: [],
  horoscopeKeywords: [],
  horoscopeAnnuals: [],
  horoscopeMonthlies: [],
  horoscopeDailies: [],

  houseDescription: [],

  meditationCategory: [],
  meditationResource: [],

  moods: [],
  moonSigns: [],

  signRelationship: [],

  yesOrNo: [],

  palmLines: [],
  palmLineTypes: [],
  palmLineSides: [],

  planetDescription: [],
  planetInSign: [],

  tarotCards: [],
  tarotFortune: [],
  tarotResults: [],

  downloadAppStatus: true
};

export default initialState;
